export default __webpack_public_path__ + "static/media/961.5aa973a3.png";